import VinWonderPriceList from './VinWonderPriceList';

export default VinWonderPriceList;